import React, { useEffect, useMemo } from 'react'
import { VNProgressCounter } from '../../../VNCustomerFacingDisplay/components/VNProgressCounter'
import { VNDialog } from '../../../VNCustomerFacingDisplay/components/VNDialog'
import { useSelector } from 'react-redux'
import { getCardAuthStepOne } from '../../Selectors'
import useSpinner from '../../../context/hooks/useSpinner'

export const VNCardAuthStepOne = () => {
  const dialogData = useSelector((state) => getCardAuthStepOne(state))
  const { showSpinner, stopSpinner } = useSpinner()
  const isOpen = dialogData?.get('open') ?? false

  const getImage = () => {
    return <VNProgressCounter count={1} total={2} />
  }

  const subTitle = useMemo(() => `Customer Authorizing Card for ${dialogData?.get('amount')}`, [dialogData])

  useEffect(() => {
    if (!isOpen) return
    if (showSpinner) {
      stopSpinner()
    }
  }, [isOpen, showSpinner, stopSpinner])

  return <VNDialog open={isOpen} image={getImage()} alignTop={true} subTitle={subTitle} />
}
